import React, { useState, useEffect } from "react";
import { serverFetch } from "@extensions";
import { useCompany } from "@redux";
import { Image, Spin, Modal } from "antd";
import { strDate2Server } from "@extensions/utils";
import { InfoCircleOutlined } from "@ant-design/icons";
import { trainerSelectionRequirement } from "@extensions/enums";
import "./catalog-sale-users.css";

const CatalogSaleUsers = ({ productId, selectedDate, onSelect, trainerSelectionRequirement: trainerReq = trainerSelectionRequirement.None, selectedUser, onUsersLoaded, isRequired }) => {
  const company = useCompany();
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState(() => selectedUser?.id || null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalUser, setModalUser] = useState(null);

  useEffect(() => {
    if (selectedUser) {
      setSelectedUserId(selectedUser.id);
    }
  }, [selectedUser]);

  useEffect(() => {
    if (productId && company) {
      fetchUsers();
    } else {
      setUsers([]);
      setSelectedUserId(null);
    }
  }, [productId, company]);

  const fetchUsers = async () => {
    if (!company || !productId) return;

    setLoading(true);
    setSelectedUserId(null);
    if (onSelect) {
      onSelect(null);
    }

    try {
      const queryParams = {
        productId: productId,
      };
      if (selectedDate) {
        queryParams.date = strDate2Server(selectedDate);
      }
      const data = await serverFetch("Online/ProductUsers", { method: "GET", queryParams: queryParams });
      setUsers(data || []);
      if (onUsersLoaded) {
        onUsersLoaded(data?.length || 0);
      }
    } catch (error) {
      console.error("Ошибка получения сотрудников:", error);

      if (onSelect) {
        onSelect(null);
      }
      if (onUsersLoaded) {
        onUsersLoaded(0);
      }
    } finally {
      setLoading(false);
    }
  };

  const handleUserSelect = (user) => {
    setSelectedUserId(user.id);
    if (onSelect) {
      onSelect(user);
    }
  };

  const openUserModal = (user) => {
    setModalUser(user);
    setIsModalOpen(true);
  };

  const closeUserModal = () => {
    setIsModalOpen(false);
    setModalUser(null);
  };

  if (loading) {
    return (
      <div className="catalog-sale-users-loading">
        <Spin size="small" />
      </div>
    );
  }

  // None (0) - нет необходимости выбирать тренера, НЕ показываем выбор
  // ClientChoose (1) - клиент ОБЯЗАН выбрать тренера, всегда показываем список без опции "Не указывать"
  // UserChoose (2) - пользователь (продавец) должен выбрать тренера, НЕ показываем выбор на клиенте
  // Both (3) - и клиент, и пользователь должны выбрать тренера, всегда показываем список без опции "Не указывать"
  const showSelector = isRequired ||
                       trainerReq === trainerSelectionRequirement.ClientChoose ||
                       trainerReq === trainerSelectionRequirement.Both;

  if (!showSelector) {
    return null;
  }

  // Если выбор обязателен, но нет доступных тренеров - не показываем селектор, позволяем продолжить без тренера
  if (users.length === 0) {
    return null;
  }

  return (
    <>
      <div className="catalog-sale-users">
      <div className="catalog-sale-users-title">Выберите сотрудника</div>
      <div className="catalog-sale-users-list">
        {users.map((u) => (
          <div
            key={u.id}
            className={`catalog-sale-users-card ${selectedUserId === u.id ? "selected" : ""}`}
            onClick={() => handleUserSelect(u)}
            style={{ position: "relative" }}
          >
            {u.imageId && (
              <div className="catalog-sale-users-photo">
                <Image
                  src={`${process.env.REACT_APP_API_BASE_URL}/api/image/${u.imageId}`}
                  alt={u.name}
                  preview={false}
                  className="catalog-sale-users-image"
                />
              </div>
            )}
            <div className="catalog-sale-users-info">
              <div className="catalog-sale-users-name">
                {u.name}
              </div>
              {u.description && (
                <InfoCircleOutlined
                  onClick={(e) => {
                    e.stopPropagation();
                    openUserModal(u);
                  }}
                  style={{ position: "absolute", top: 8, right: 8, cursor: "pointer", color: "#8c8c8c" }}
                />
              )}
              {u.position && <div className="catalog-sale-users-position">{u.position}</div>}
            </div>
          </div>
        ))}
      </div>
    </div>
    <Modal
      title="Информация о сотруднике"
      open={isModalOpen}
      onCancel={closeUserModal}
      footer={null}
      centered
      width={700}
    >
      {modalUser && (
        <div className="trainer-modal-content">
          {modalUser.imageId && (
            <div className="trainer-modal-photo-container">
              <img
                src={`${process.env.REACT_APP_API_BASE_URL}/api/image/${modalUser.imageId}`}
                alt={modalUser.name}
                className="trainer-modal-photo"
              />
            </div>
          )}
          <div className="trainer-modal-info">
            <div className="trainer-modal-name">{modalUser.name}</div>
            {modalUser.position && (
              <div className="trainer-modal-position">{modalUser.position}</div>
            )}
            <div className="trainer-modal-description">
              {modalUser.description}
            </div>
          </div>
        </div>
      )}
    </Modal>
  </>
  );
};

export default CatalogSaleUsers;
